import { IntroSection, FounderSection, ScopeNote } from "@/components/marketing/AboutSections";

export default function About() {
  return (
    <div className="fade-in-up">
      <IntroSection />
      <FounderSection />
      <ScopeNote />
    </div>
  );
}
